import { DateRangeCalendar } from 'components/DateRangePicker'
import { TextField, Dropdown } from 'monday-ui-react-core'
import { Col } from 'react-bootstrap'
import './ProductBalancing.scss'

export function ProductBalancingAdvancedSearch({
    setStatementDates,
    setOperator,
    setReportingCenter,
    setReportingCenterName,
    setApiNumber,
    setOwnerNumber,
    setOwnerName,
    setRunNames,
    runNameOptions,
    runNames,
    type,
    statementDateFrom,
    statementDateTo,
    onClear
}) {
    return (
        <>
            <Col lg={12} className="d-none d-lg-block mb-5">
                <div className="d-flex gap-3 advance-search-container">
                    <Col className="d-flex flex-column gap-3">
                        <div>
                            <label className="fw-bold" htmlFor="operator">
                                Operator
                            </label>
                            <TextField
                                id="operator"
                                name="operator"
                                value={''}
                                onChange={setOperator}
                                placeholder="Operator"
                                size={TextField.sizes.SMALL}                                       
                            />
                        </div>
                        <div>
                            <label className="fw-bold" htmlFor="statementDates">
                                Statement Date
                            </label>
                            <DateRangeCalendar
                                style={{height: '15px',}}
                                onChange={setStatementDates} from={statementDateFrom} to={statementDateTo}
                            />
                        </div>
                        {
                        type === 'sender' ? (
                        <div>
                            <label className="fw-bold" htmlFor="runName">
                                Run Name(s)
                            </label>
                            <Dropdown
                                defaultValue={[]}
                                options={runNameOptions}
                                value={runNames}
                                onChange={setRunNames}
                                placeholder="Run Name(s)"
                                multi
                                size="small"                                
                                className="dropdown-stories-styles_with-chips"
                                onClear={onClear}
                                />
                        </div>
                        ) : (
                            <></>
                        )}
                    </Col>
                    <Col className="d-flex flex-column gap-3">
                        <div>
                            <label className="fw-bold" htmlFor="reportingCenter">
                                Reporting Center
                            </label>
                            <TextField
                                id="reportingCenter"
                                name="reportingCenter"
                                value={''}
                                onChange={setReportingCenter}
                                placeholder="Reporting Center"
                                size={TextField.sizes.SMALL}
                            />
                        </div>
                        <div style={{display: 'none'}} >
                            <label className="fw-bold" htmlFor="ownerNumber">
                                Owner Number
                            </label>
                            <TextField
                                id="ownerNumber"
                                name="ownerNumber"
                                value={''}
                                onChange={setOwnerNumber}
                                placeholder="Owner Number"
                                size={TextField.sizes.SMALL}
                            />
                        </div>
                        <div>
                            <label className="fw-bold" htmlFor="apiNumber">
                                API Number
                            </label>
                            <TextField
                                id="apiNumber"
                                name="apiNumber"
                                value={''}
                                onChange={setApiNumber}
                                placeholder="API Number"
                                size={TextField.sizes.SMALL}
                            />
                        </div>
                    </Col>
                    <Col className="d-flex flex-column gap-3">
                    <div>
                            <label className="fw-bold" htmlFor="reportingCenterName">
                                Reporting Center Name
                            </label>
                            <TextField
                                id="reportingCenterName"
                                name="reportingCenterName"
                                value={''}
                                onChange={setReportingCenterName}
                                placeholder="Reporting Center Name"
                                size={TextField.sizes.SMALL}
                            />
                        </div>
                        <div style={{display: 'none'}}>
                            <label className="fw-bold" htmlFor="ownerName">
                                Owner Name
                            </label>
                            <TextField
                                id="ownerName"
                                name="ownerName"
                                value={''}
                                onChange={setOwnerName}
                                placeholder="Owner Name"
                                size={TextField.sizes.SMALL}
                            />
                        </div>
                    </Col>
                </div>
            </Col>
            <Col xs={12} className="d-lg-none d-xs-block d-md-block mb-5">
                <div className="advance-search-container">
                    <div>
                        <label className="fw-bold" htmlFor="operator">
                                Operator
                        </label>
                        <TextField
                            id="operator"
                            name="operator"
                            value={''}
                            onChange={setOperator}
                            placeholder="Operator"
                            size={TextField.sizes.SMALL}                                       
                        />
                    </div>
                    <div className="mt-3">
                        <label className="fw-bold" htmlFor="statementDates">
                            Statement Date
                        </label>
                        <DateRangeCalendar
                            style={{
                                height: '15px',
                            }}
                            onChange={setStatementDates}
                        />
                    </div>
                    <div className="mt-3">
                        <label className="fw-bold" htmlFor="reportingCenter">
                                Reporting Center
                        </label>
                        <TextField
                            id="reportingCenter"
                            name="reportingCenter"
                            value={''}
                            onChange={setReportingCenter}
                            placeholder="Reporting Center"
                            size={TextField.sizes.SMALL}
                        />
                    </div>
                    <div className="mt-3">
                        <label className="fw-bold" htmlFor="ownerNumber">
                                Owner Number
                        </label>
                        <TextField
                            id="ownerNumber"
                            name="ownerNumber"
                            value={''}
                            onChange={setOwnerNumber}
                            placeholder="Owner Number"
                            size={TextField.sizes.SMALL}
                        />
                    </div>
                    <div className="mt-3">
                        <label className="fw-bold" htmlFor="apiNumber">
                            API Number
                        </label>
                        <TextField
                            id="apiNumber"
                            name="apiNumber"
                            value={''}
                            onChange={setApiNumber}
                            placeholder="API Number"
                            size={TextField.sizes.SMALL}
                        />
                    </div>
                    <div className="mt-3">
                        <label className="fw-bold" htmlFor="reportingCenterName">
                                Reporting Center Name
                        </label>
                        <TextField
                            id="reportingCenterName"
                            name="reportingCenterName"
                            value={''}
                            onChange={setReportingCenterName}
                            placeholder="Reporting Center Name"
                            size={TextField.sizes.SMALL}
                        />
                    </div>
                    <div className="mt-3">
                        <label className="fw-bold" htmlFor="ownerName">
                            Owner Name
                        </label>
                        <TextField
                            id="ownerName"
                            name="ownerName"
                            value={''}
                            onChange={setOwnerName}
                            placeholder="Owner Name"
                            size={TextField.sizes.SMALL}
                        />
                    </div>
                    {
                        type === 'sender' ? (
                        <div className="mt-3">
                            <label className="fw-bold" htmlFor="runName">
                                Run Name(s)
                            </label>
                            <Dropdown
                                defaultValue={[]}
                                options={runNameOptions}
                                value={runNames}
                                onChange={setRunNames}
                                placeholder="Run Name(s)"
                                multi
                                size="small"                                
                                className="dropdown-stories-styles_with-chips"
                                onClear={onClear}
                                />
                        </div>
                        ) : (
                            <></>
                        )}
                </div>
            </Col>
        </>
    )
}
